module.exports = __webpack_public_path__ + "img/tapas.5795f610.png";